import React from 'react';
import dynamic from 'next/dynamic';
import cx from 'clsx';
import { CSSTransition } from 'react-transition-group';
import { Anchor, NavigationMenu } from '../../util/types';
import classes from './MobileMenu.module.scss';

const MobileButton = dynamic(() => import('./MobileButton/MobileButton'));

export interface MobileMenuProps extends React.HTMLProps<HTMLDivElement> {
  opened?: boolean;
  menu?: { fields: NavigationMenu }[];
  roi?: { fields: Anchor };
}

export default function MobileMenu({
  className,
  opened,
  menu,
  roi,
  ...others
}: MobileMenuProps) {
  return (
    <CSSTransition
      in={opened}
      unmountOnExit
      timeout={200}
      classNames={classes}
    >
      <div className={cx(className, classes.mobileMenu)} {...others}>
        {menu?.map((item, index) => (
          <MobileButton
            key={index}
            {...item.fields}
            button={item.fields.button.fields}
            withLinks={item.fields.withLinks}
            // eslint-disable-next-line react/no-children-prop
            children={item.fields.children?.map(child => child.fields)}
          />
        ))}
        <MobileButton key={menu?.length} button={roi?.fields} />
      </div>
    </CSSTransition>
  );
}

MobileMenu.displayName = '@ioa/lablocator/MobileMenu';
